import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './AthleteUserPurchasesValidation';

import NavLinks from '../../../meet/NavLinks';
import EntryNavLinks from '../../EntryNavLinks';
import MyMeetsNavLinks from '../../../myMeets/MyMeetsNavLinks';
import MyAthleteEntryNavLinks from '../../../myAthleteEntry/MyAthleteEntryNavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOrgUnitAthleteEntryInfoData from '../../../../state/orgUnitAthleteEntryInfo/UseOrgUnitAthleteEntryInfoData';
import useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData from '../../../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData';
import useOrgUnitAthleteEntryPurchaseData from '../../../../state/orgUnitAthleteEntryPurchase/UseOrgUnitAthleteEntryPurchaseData';
import useAthleteEntryContextData from '../../../../state/athleteEntryContextView/UseAthleteEntryContextData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import useMyAthleteMeetEntriesFiltersData from '../../../../state/myAthleteMeetEntriesFilters/UseMyAthleteMeetEntriesFiltersData';
import useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData from '../../../../state/omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntry/UseOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData';

import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import useForm from '@usas/ui-web/utils/UseForm';
import ToIntIfInt from '@usas/ui-web/utils/ToIntIfInt';
import { FormatMoneyWithSymbol } from '@usas/ui-web/utils/FormatMoney';

import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_FORM_STATE = {
};

const INITIAL_MODAL_STATE = {
  displayPopUp: false,
  modalTitle: 'Delete Purchase Item?',
  referenceId: Constants.DEFAULT_ID,
  referenceEntity: '',
  itemDescription: '',
  itemPrice: '',
};

const useAthleteUserPurchases = () => {
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData();
  const { orgUnitAthleteEntryInfoState, getOrgUnitAthleteEntryInfo } = useOrgUnitAthleteEntryInfoData();
  const { omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, getOrgUnitAthleteEntryIndividualRosterEntryByOrgUnitAthleteEntryId } = useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
  const { omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState, getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentials } = useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData();
  const { orgUnitAthleteEntryPurchaseState, setOrgUnitAthleteEntryPurchaseState, getOrgUnitAthleteEntryPurchaseByOrgUnitAthleteEntryId, postOrgUnitAthleteEntryPurchase,
    deleteOrgUnitAthleteEntryPurchase } = useOrgUnitAthleteEntryPurchaseData();
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { athleteEntryContextState, setAthleteEntryContextState } = useAthleteEntryContextData();
  const { myAthleteMeetEntriesFiltersState } = useMyAthleteMeetEntriesFiltersData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const { errorState, formState, handleSubmit, updateFormState, setFormData, setIsDirty
  } = useForm(INITIAL_FORM_STATE, submitFormCallback, validate);
  const [state, setState] = useState({ tryRedirect: false, tryGet: false, showPayButton: false });
  const [modalState, setModalState] = useState(INITIAL_MODAL_STATE);

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.ATHLETE_CREDENTIALS);
    }
    else {
      //Meet Route
      navigate(NavLinks.ATHLETE_CREDENTIALS);
    }
  };

  const onExitButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (omeMeetState.route === '') {
      if (selectOrgUnitState.orgUnitId === '') {
        //My Athlete Meet Entries Route
        navigate(MyAthleteEntryNavLinks.MY_ATHLETE_ENTRY, { state: { myAthleteMeetEntriesFiltersState: myAthleteMeetEntriesFiltersState } });
      }
      else {
        //OME Route
        navigate(MyMeetsNavLinks.MEET_ENTRY_ATHLETE, { state: { selectOrgUnitState: selectOrgUnitState } });
      }
    }
    else {
      //Meet Route
      setSearchMeetState({ ...searchMeetState, showMeetHeader: true });

      navigate(NavLinks.MEET_ENTRY_ATHLETE, { state: { goToMeet: true } });
    }
  };

  const onDeletePurchaseItemDetailClicked = (e, purchaseItemDetail) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState({
      ...modalState,
      displayPopUp: true,
      referenceId: purchaseItemDetail.referenceId || Constants.DEFAULT_ID,
      referenceEntity: purchaseItemDetail.referenceEntity || '',
      itemDescription: purchaseItemDetail.itemDescription || '',
      itemPrice: purchaseItemDetail.itemPrice >= 0 ? FormatMoneyWithSymbol(purchaseItemDetail.itemPrice) : ''
    });
  };

  const onDeletePurchaseItem = (e, referenceEntity, referenceId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    deleteOrgUnitAthleteEntryPurchase(orgUnitAthleteEntryInfoState.objData?.orgUnitAthleteEntryId, referenceEntity, referenceId);
    onModalCanceled();
    setState({ ...state, tryGet: true });
  }

  const onModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState(INITIAL_MODAL_STATE);
  };

  function submitAthleteEntryAllowed() {
    //At least one entry contact must be provided
    if (orgUnitAthleteEntryInfoState.objData?.hasEntryContact === false) {
      return false;
    }
    //All athlete events must be approved
    if (orgUnitAthleteEntryInfoState.objData?.hasApprovedEvents === false) {
      return false;
    }
    //Number of credential is allowed
    if (orgUnitAthleteEntryInfoState.objData?.credentialsAmountAllowed === false) {
      return false;
    }

    return true;
  }

  useEffect(() => {
    const additionalPurchaseWithQuantityOtherThanZero = orgUnitAthleteEntryPurchaseState.objData.additionalPurchase?.find(x => x.quantity > 0) ? true : false;
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: !additionalPurchaseWithQuantityOtherThanZero });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUnitAthleteEntryPurchaseState.objData.additionalPurchase]);

  useEffect(() => {
    setAthleteEntryContextState({ ...athleteEntryContextState, showNav: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId &&
      omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.omeMeetOrgUnitEntryId) {
      getOrgUnitAthleteEntryIndividualRosterEntryByOrgUnitAthleteEntryId(
        omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId,
        omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.omeMeetOrgUnitEntryId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId,
  omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.omeMeetOrgUnitEntryId])

  useEffect(() => {
    if (omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isObjLoaded === true && omeMeetState.isObjLoaded === true) {
      getOrgUnitAthleteEntryPurchaseByOrgUnitAthleteEntryId(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.orgUnitAthleteEntryId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, omeMeetState])

  useEffect(() => {
    if (state.tryGet === true && orgUnitAthleteEntryPurchaseState.isSaving === false) {
      getOrgUnitAthleteEntryIndividualRosterEntryByOrgUnitAthleteEntryId(
        omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId,
        omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.omeMeetOrgUnitEntryId);
      getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentials(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId);
      getOrgUnitAthleteEntryPurchaseByOrgUnitAthleteEntryId(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.orgUnitAthleteEntryId);
      getOrgUnitAthleteEntryInfo(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId);
      setState({ ...state, tryGet: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryGet, orgUnitAthleteEntryPurchaseState])

  useEffect(() => {
    if (orgUnitAthleteEntryPurchaseState.isObjLoaded === true && Object.keys(omeMeetState.objData).length > 0) {
      if (orgUnitAthleteEntryPurchaseState.objData.purchaseItem) {
        setFormData({
          ...formState,
        });
        setIsDirty(true);

        const purchaseItemWithQuantityOtherThanZero = orgUnitAthleteEntryPurchaseState.objData.purchaseItem?.find(x => x.quantity > 0) ? true : false;
        const additionalPurchaseWithQuantityOtherThanZero = orgUnitAthleteEntryPurchaseState.objData.additionalPurchase?.find(x => x.quantity > 0) ? true : false;
        if (purchaseItemWithQuantityOtherThanZero === true || additionalPurchaseWithQuantityOtherThanZero === true) {
          setState({ ...state, showPayButton: true });
        }
        else {
          setState({ ...state, showPayButton: false });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUnitAthleteEntryPurchaseState, omeMeetState.objData])

  useEffect(() => {
    if (state.tryRedirect === true && orgUnitAthleteEntryPurchaseState.isSaved === true) {
      if (omeMeetState.route === '') {
        //OME Route
        navigate(EntryNavLinks.ATHLETE_PAYMENTS);
      }
      else {
        //Meet Route
        navigate(NavLinks.ATHLETE_PAYMENTS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryRedirect, orgUnitAthleteEntryPurchaseState])

  function submitFormCallback() {
    setAthleteEntryContextState({ ...athleteEntryContextState, showNav: false });
    postOrgUnitAthleteEntryPurchase(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId, createOrgUnitAthleteEntryPurchaseObject());
    setState({ ...state, tryRedirect: true });
  }

  function createOrgUnitAthleteEntryPurchaseObject() {
    const orgUnitAthleteEntryPurchaseStateCopy = JSON.parse(JSON.stringify(orgUnitAthleteEntryPurchaseState.objData.additionalPurchase));
    return orgUnitAthleteEntryPurchaseStateCopy !== null ? orgUnitAthleteEntryPurchaseStateCopy : [];
  }

  function onAdditionalPurchaseValueChanged(purchaseItem, value) {
    const orgUnitAthleteEntryPurchaseStateCopy = JSON.parse(JSON.stringify(orgUnitAthleteEntryPurchaseState.objData));
    const selectedItemIndex = orgUnitAthleteEntryPurchaseStateCopy?.additionalPurchase.findIndex(x => x.omeMeetPriceId === purchaseItem.omeMeetPriceId);
    if (selectedItemIndex > -1) {
      const valueInt = ToIntIfInt(value);
      const valueInteger = valueInt ? parseInt(valueInt).toFixed(0) : 0;
      if (valueInt >= 0 && valueInt <= 1000000) {
        const totalAmount = valueInt * orgUnitAthleteEntryPurchaseStateCopy.additionalPurchase[selectedItemIndex].amount;
        const totalAmountRounded = totalAmount.toFixed(2);
        orgUnitAthleteEntryPurchaseStateCopy.additionalPurchase[selectedItemIndex] = {
          ...orgUnitAthleteEntryPurchaseStateCopy.additionalPurchase[selectedItemIndex],
          quantity: valueInteger,
          totalAmount: totalAmountRounded
        }
      }
    }
    setOrgUnitAthleteEntryPurchaseState({
      ...orgUnitAthleteEntryPurchaseState,
      objData: orgUnitAthleteEntryPurchaseStateCopy
    });

    const purchaseItemWithQuantityOtherThanZero = orgUnitAthleteEntryPurchaseStateCopy.purchaseItem?.find(x => x.quantity > 0) ? true : false;
    const additionalPurchaseWithQuantityOtherThanZero = orgUnitAthleteEntryPurchaseStateCopy.additionalPurchase?.find(x => x.quantity > 0) ? true : false;
    if (purchaseItemWithQuantityOtherThanZero === true || additionalPurchaseWithQuantityOtherThanZero === true) {
      setIsDirty(true);
      setState({ ...state, showPayButton: true });
    }
    else {
      setState({ ...state, showPayButton: false });
    }
  }

  return {
    athleteEntryContextState,
    state,
    omeMeetState,
    orgUnitAthleteEntryInfoState,
    orgUnitAthleteEntryPurchaseState,
    omeMeetOrgUnitAthleteEntryIndividualRosterEntryState,
    omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState,
    errorState,
    formState,
    onFormValueChanged: updateFormState,
    handleSubmit,
    onAdditionalPurchaseValueChanged,
    submitAthleteEntryAllowed,
    onBackClicked,
    modalState,
    onModalCanceled,
    onDeletePurchaseItemDetailClicked,
    onDeletePurchaseItem,
    onExitButtonClicked
  };
}

export default useAthleteUserPurchases;